var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFAnalytic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#008060",
  fillRule: "evenodd",
  d: "M14.586 1.895a.947.947 0 1 0-.9-.649l-2.35 1.764a.947.947 0 0 0-1.387 1.203L7.43 6.73a.945.945 0 0 0-1.146.235L3.215 5.74l.002-.054a.947.947 0 1 0-.224.611L6.06 7.523l-.002.056a.947.947 0 1 0 1.795-.424l2.519-2.518a.947.947 0 0 0 1.323-1.147l2.35-1.764a.94.94 0 0 0 .54.169M12.69 5.137c0-.221.179-.4.4-.4h2.042c.22 0 .4.179.4.4v11.915h1.895V18H.375v-.948h4.737v-4.336c0-.221.179-.4.4-.4h2.042c.22 0 .4.179.4.4v4.336H8.9V7.98c0-.22.18-.4.4-.4h2.042c.221 0 .4.18.4.4v9.073h.948zM1.722 9.473a.4.4 0 0 0-.4.4v7.18h2.842v-7.18a.4.4 0 0 0-.4-.4z",
  clipRule: "evenodd"
})));
export { SvgFAnalytic as ReactComponent };
export default __webpack_public_path__ + "static/media/f-analytic.837d493f.svg";